
import wx from 'weixin-js-sdk'

import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'


export default {
name: 'order',
directives: {
TransferDom
},
components: {
cmBlank,cmLoadmore,PopupPicker,Previewer,Popup,XButton,Radio, Group,PopupHeader,Checklist,XTextarea,Datetime
},
data () {
return {
title:'全部订单',
startDate:'',
minHour:6,
maxHour:20,
minuteList:['00','30'],
popBg:false,
timePop:false,
datetimeStatus:false,
isActive:0,
blankShow:false,
loadStatus:false,
showCommentStatus:false,
showResetStatus:false,
showCancelStatus:false,
showQuery:false,
sortStatus:false,
rewardStatus:false,
pickerSelectWorkerStatus:false,
selectWorkerId:0,
selectWorkerTitle:'请选择',
sortSelectType:'',
loadmoreText:'正在加载。。。',
busy:false,
phone:'',
pageFlag:2,
hasNext:0,
lastId:0,
id:0,
itemIndex:0,
itemId:0,
list:[],
pickerGroupStatus:false,
pickerWorkerStatus:false,
check:'/static/images/start@2x.png',
checked:'/static/images/started@2x.png',
group:[],
groupId:0,
rewardAmount:'',
worker:[],
workerId:[],
grade:0,
pay_status:'',
scope:0,
content:'',
commented:'',
sortNum:0,
isAssign:0,
waitPay:0,
isTransferOrder:false,
payStatusArr:[
{
key:'',
value:'全部',
},
{
key:0,
value:'未支付',
},
{
key:1,
value:'已支付'
},
],
commentedArr:[
{
key:'',
value:'全部',
},
{
key:1,
value:'已回访'
},
{
key:0,
value:'未回访',
},
],
orderScope:[
{
key:0,
value:'全部'
},
{
key:1,
value:'本人订单'
},
{
key:2,
value:'组员订单'
},
],
orderStatusArr:['全部订单','待分配','待抢单','待上门','拆卸中','待安装','服务完成','已撤销'],

dateList: [],
dateStr: '',
home_time: '',
old_home_time: '',
dateIndex: 0,
dateHomeStatus: false,
startHomeDate: '',
endHomeDate: '',
}
},
created(){
this.isActive = Number(this.$route.params.i);
this.commented = this.$route.params.commented;
this.grade = parseInt(this.$func.getLocal('grade'));
this.setDate();
this.loadmore();
this.$route.meta.title = this.orderStatusArr[this.isActive];
document.title = this.$route.meta.title;
},
mounted(){
this.buildDateList();
if(this.grade == 23 || this.grade == 24){
if(this.grade == 23){
this.getWorker();
}
}else{
this.getCurtainGroup();

}
this.config();
},
methods:{
async buildDateList(){
const weekMap = ['周日','周一','周二','周三','周四','周五','周六'];
const list = [];
const mkDate = await this.getCurtainOrderDateCount();
if(this.grade == 23 || this.grade == 24){
list.push({ value: '', label: '全部', display: '' ,num:mkDate.all});
}else{
list.push({ value: '', label: '全部', display: '' ,num:mkDate.all});
if(this.isActive < 2 && this.startHomeDate == ''){
list.push({ value: 'wait', label: '未设置', display: '' ,num:mkDate.wait});
}
}
for(let i=0;i<15;i++){
const d = new Date();
d.setDate(d.getDate()+i);
const yyyy = d.getFullYear();
const mm = String(d.getMonth()+1).padStart(2,'0');
const dd = String(d.getDate()).padStart(2,'0');
const value = `${yyyy}-${mm}-${dd}`;
let label = '';
let display = '';
let num = 0;
if(i===0){
label = '今天';
display = `${mm}-${dd}`;

} else if(i===1){
label = '明天';
display = `${mm}-${dd}`;
} else if(i===2){
label = '后天';
display = `${mm}-${dd}`;
} else {

label = `${mm}-${dd}`;

display = weekMap[d.getDay()];
}
num = mkDate[value] || 0;
list.push({ value, label, display,num });
}
this.dateList = list;
console.log(this.dateList);
},
async getCurtainOrderDateCount(){
try{
var where = {
phone:this.phone,
pay_status:this.pay_status,
status:this.isActive,
commented:this.commented,
scope:this.scope,
home_date:this.dateStr,
start_home_date:this.startHomeDate,
end_home_date:this.endHomeDate,
worker_id:this.selectWorkerId,
}
const res = await this.$api.getCurtainOrderDateCount(where);
return res ? res.data : {};
}catch(e){
console.error('getCurtainOrderDateCount error', e);
return {};
}
},
async getCurtainOrderPayCount(){
try{
const res = await this.$api.getCurtainOrderPayCount({status:this.isActive});
this.waitPay = res.data || 0;
}catch(e){
console.error('getCurtainOrderDateCount error', e);
return {};
}
},
showHomeDate(e){
this.dateIndex = e;
this.dateHomeStatus = true;
},
dateHomeChange(e){
if(this.dateIndex > 0){
this.endHomeDate = e;
}else{
this.startHomeDate = e;
}
},
onChangeSelectWorker (value) {
console.log(value);
this.selectWorkerId = value;
this.selectWorkerTitle = value ? this.worker.find(item => item.key == value).value : '请选择';
},
selectDate(val){
this.loadStatus = false;
this.dateStr = val;
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
},
setDate() {
var nowDate = new Date();
var date = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
}
this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
},
datetimeChange(val){
this.home_time = val;
},
editHomeTime(id,index){
this.itemId = id;
this.home_time = this.list[index].home_time;
this.old_home_time = this.list[index].home_time;
this.popBg = true;
this.timePop = true;
},
submitEditHomeTime(){
if(!this.itemId){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(!this.home_time){
this.$func.showToast('请选择上门时间');
return false;
}
if(this.home_time == this.old_home_time){
if(this.isAssign > 0){
this.datetimeStatus = false;
this.popBg = false;
this.timePop = false;
this.pickerWorkerStatus = true;
return ;
}
}
this.$func.confirm('确认操作？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.curtainEditHomeTime({id:this.itemId,home_time:this.home_time}).then((res)=>{
if(res){
this.$func.endLoading();
if(this.isAssign > 0){
this.datetimeStatus = false;
this.popBg = false;
this.timePop = false;
this.pickerWorkerStatus = true;
}else{
setTimeout(()=>{
this.datetimeStatus = false;
this.popBg = false;
this.timePop = false;
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.itemId = 0;
this.loadmore();
}, 300);
}
}
});
})
},
clearHomeTime(){
if(!this.itemId){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.curtainEditHomeTime({id:this.itemId,home_time:0}).then((res)=>{
if(res){
this.$func.endLoading();
if(this.isAssign > 0){
this.datetimeStatus = false;
this.popBg = false;
this.timePop = false;
this.pickerWorkerStatus = true;
}else{
setTimeout(()=>{
this.datetimeStatus = false;
this.popBg = false;
this.timePop = false;
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.itemId = 0;
this.loadmore();
}, 300);
}
}
});
})
},
payStatus(id){
this.$func.confirm('确认已付款？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.curtainPayStatus({id:id}).then((res)=>{
if(res){
this.$func.endLoading();
setTimeout(()=>{
this.datetimeStatus = false;
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
}, 300);
}
});
})
},
copy(val){
this.$func.copy(val,event);
},
reset(){
this.loadStatus = false;
this.showQuery = false;
this.phone = '';
this.pay_status = '';
this.startHomeDate = '';
this.endHomeDate = '';
this.selectWorkerTitle = '请选择';
this.selectWorkerId = 0;
this.scope = 0;
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
this.buildDateList();
},
search(){
this.loadStatus = false;
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
this.buildDateList();
},
selectPayStatus(key){
this.pay_status = key;
},
selectScope(key){
this.scope = key;
},
selectCommented(key){
this.commented = key;
},
curtainSort(id){
this.itemId = id;
this.popBg = true;
this.sortStatus = true;
},
setReward(id,index){
this.itemId = id;
this.rewardAmount = 0;
this.itemIndex = index;
this.popBg = true;
this.rewardStatus = true;
console.log(this.itemIndex);
},
sortSelect(type){
this.sortSelectType = type;
},
getList(){
var where = {
last_id:this.lastId,
page_flag:this.pageFlag,
phone:this.phone,
pay_status:this.pay_status,
status:this.isActive,
commented:this.commented,
scope:this.scope,
home_date:this.dateStr,
worker_id:this.selectWorkerId,
start_home_date:this.startHomeDate,
end_home_date:this.endHomeDate,
}
this.$api.getCurtainOrder(where).then((res)=>{
if(res){
if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
res.data.forEach((item)=>{
this.list.push(item);
});
}
})
},
changeStatus(id,status){
if(!id){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(status == 2 && !this.groupId){
this.$func.showToast('请选择拆装组');
return false;
}
if(status == 3 && !this.workerId.length){
this.$func.showToast('请选择拆装师傅');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.changeCurtainStatus({id:id,status:status,groupId:this.groupId,workerId:this.workerId,isTransferOrder:this.isTransferOrder ? 1 : 0}).then((res)=>{
if(res){
this.$func.endLoading();
this.$func.showToast('操作成功');
setTimeout(()=>{
this.pickerGroupStatus = false;
this.pickerWorkerStatus = false;
this.isTransferOrder = false;
this.list = [];
this.lastId = 0;
this.itemId = 0;
this.hasNext = 0;

this.loadmore();
}, 300);
}
});
})
},
submitSort(){
if(!this.itemId){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(!this.sortSelectType){
this.$func.showToast('请选择排序方式');
return false;
}
if(this.sortSelectType == 'number' && !this.sortNum){
this.$func.showToast('请输入排名');
return false;
}
this.$func.startLoading('请求中。。。');
this.$api.curtainSort({id:this.itemId,type:this.sortSelectType,num:this.sortNum}).then((res)=>{
if(res){
this.$func.endLoading();
setTimeout(()=>{
this.popBg = false;
this.sortStatus = false;
this.sortSelectType = '';
this.sortNum = 0;
this.itemId = 0;
this.list = [];
this.lastId = 0;
this.hasNext = 0;

this.loadmore();
}, 300);
}
})
},
submitReward(){
if(!this.itemId){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(this.rewardAmount <= 0){
this.$func.showToast('请输入佣金金额');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.curtainReward({id:this.itemId,amount:this.rewardAmount}).then((res)=>{
if(res){
this.$func.endLoading();
setTimeout(()=>{
this.popBg = false;
this.rewardStatus = false;
this.list[this.itemIndex].amount = this.rewardAmount;
this.rewardAmount = 0;
this.itemIndex = 0;
}, 300);
}
})
})
},
grabOrder(id){
if(!id){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
this.$func.confirm('确认抢单？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.curtainGrabOrder({id:id}).then((res)=>{
if(res){
this.$func.endLoading();
this.$func.showToast('操作成功');
setTimeout(()=>{
this.list = [];
this.lastId = 0;
this.hasNext = 0;

this.loadmore();
}, 300);
}
});
})
},
curtainOrderEdit(id){
this.$router.push({name:'createCurtainOrder',params:{id:id}})
},
detail(id){
this.$router.push({name:'curtainOrderInfo',params:{id:id}})
},
curtainMapOrder(id){
this.$router.push({name:'curtainMapOrder',params:{status:this.isActive,dateStr:this.dateStr}})
},
assignGroup(id){
this.itemId = id;
this.pickerGroupStatus = true;
},
onGroupChange (value) {
this.groupId = value;
},
assignWorker(id,index){
this.itemId = id;
this.isAssign = 1;
this.editHomeTime(id,index);
},
onWorkerChange (value) {
this.workerId = value;
},
transferOrder(id){
this.itemId = id;
this.isTransferOrder = true;
this.getWorker();
this.popBg = true;
this.pickerWorkerStatus = true;
},
getCurtainGroup() {
this.$api.getCurtainGroup({}).then((res)=>{
if(res){
this.group = res.data;
}
})
},
getWorker() {
this.$api.getCurtainWorker({}).then((res)=>{
if(res){
this.worker = res.data;
}
})
},
closePop(){
this.popBg = false;
this.timePop = false;
this.sortStatus = false;
this.rewardStatus = false;
this.sortSelectType = '';
this.sortNum = 0;
this.itemId = 0;
this.itemIndex = 0;
this.rewardAmount = 0;
},
showComment(id,index){
this.itemId = id;
this.itemIndex = index;
this.content = '';
this.showCommentStatus = true;
},
submitComment(){
if(!this.itemId){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(!this.content){
this.$func.showToast('请输入回访结果');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.curtainComment({id:this.itemId,content:this.content}).then((res)=>{
if(res){
this.$func.endLoading();
this.$func.showToast('操作成功');
setTimeout(()=>{
this.showCommentStatus = false;





this.list[this.itemIndex].commented = 1;
}, 300);
}
});
})
},
resetCurtainOrderStatus(id){
this.itemId = id;
this.content = '';
this.showResetStatus = true;
},
submitReset(){
if(!this.itemId){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(!this.content){
this.$func.showToast('请输入订单重置原因');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.resetCurtainOrder({id:this.itemId,content:this.content}).then((res)=>{
if(res){
this.$func.endLoading();
this.$func.showToast('操作成功');
setTimeout(()=>{
this.showResetStatus = false;
this.list = [];
this.lastId = 0;
this.hasNext = 0;

this.loadmore();
}, 300);
}
});
})
},
cancelCurtainOrder(id){
this.itemId = id;
this.content = '';
this.showCancelStatus = true;
},
submitCancel(){
if(!this.itemId){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(!this.content){
this.$func.showToast('请输入订单撤销原因');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$func.startLoading('请求中。。。');
this.$api.cancelCurtainOrder({id:this.itemId,content:this.content}).then((res)=>{
if(res){
this.$func.endLoading();
this.$func.showToast('操作成功');
setTimeout(()=>{
this.showCancelStatus = false;
this.list = [];
this.lastId = 0;
this.hasNext = 0;

this.loadmore();
}, 300);
}
});
})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false, //调试阶段建议开启
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"openLocation",
]
});
}
})
},
openLocation(info){
wx.openLocation({
latitude: info.lat, // 纬度，浮点数，范围为90 ~ -90
longitude: info.lng, // 经度，浮点数，范围为180 ~ -180。
name: info.address, // 位置名
address: info.address, // 地址详情说明
scale: 16, // 地图缩放级别,整型值,范围从1~28。默认为最大
infoUrl: '' 
});
},
loadmore(){
console.log(this.lastId, this.hasNext);
if(this.lastId > 0 && !this.hasNext){
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
return ;
}
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '正在加载。。。';
setTimeout(()=>{
this.getList();
}, 300);
setTimeout(()=>{
if(this.blankShow){
this.busy = true;
this.loadStatus = false;
this.loadmoreText = '没有更多了。。。'
}else{
if(this.hasNext > 0){
this.loadStatus = false;
this.busy = false;
}else{
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
}
}
},1500)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/curtainOrder.vue